export default () => `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <title>Accept a card payment</title>
    <meta name="description" content="A demo of a card payment on Stripe" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    <link rel="stylesheet" href="global.css" />
    {+load-stripe}
    <script src="https://js.stripe.com/v3/"></script>
    {/load-stripe}
    <script src="https://polyfill.io/v3/polyfill.min.js?version=3.52.1&features=fetch"></script>
    <script src="client.js" defer></script>
  </head>

  <body>
    <!-- Display a payment form -->
    {+build-form}
    <form id="payment-form">
      {?email email-0}
      <input type="text" id="email" placeholder="Email address" />
      {/email-0}
      <div id="card-element"><!--Stripe.js injects the Card Element--></div>
      <button id="submit">
        <div class="spinner hidden" id="spinner"></div>
        <span id="button-text">Pay now</span>
      </button>
      <p id="card-error" role="alert"></p>
      <p class="result-message hidden">
        Payment succeeded, see the result in your
        <a href="" target="_blank">Stripe dashboard.</a> Refresh the page to pay again.
      </p>
    </form>
    {/build-form}
  </body>
</html>
`;
